module.exports = __webpack_public_path__ + "static/media/UberLogo.7c9dc6c5.png";